/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HazardFactorStatusDto } from '../../models/hazard-factor-status-dto';

export interface UpdateHazardFactors$Params {

/**
 * The customer id
 */
  customerId: number;
      body: Array<HazardFactorStatusDto>
}

export function updateHazardFactors(http: HttpClient, rootUrl: string, params: UpdateHazardFactors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HazardFactorStatusDto>>> {
  const rb = new RequestBuilder(rootUrl, updateHazardFactors.PATH, 'patch');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HazardFactorStatusDto>>;
    })
  );
}

updateHazardFactors.PATH = '/customers/{customerId}/hazard-factors';
